"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    p {
        margin-bottom: 2em;
        &.centered {
            text-align: center;
        }
    }
    .buttonContainer {
        text-align: center;
    }
    .btn {
        @media screen and ${constants_1.Device.mobileL} {
            width: 100% !important;
            margin-bottom: 2em;
        }
    }
`;
//# sourceMappingURL=RedeemContainer.js.map